<div class="dialog-main">
    <div class="dialog">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <h3>Kérem adja meg a csomagárat!</h3>
        <div class="text">
            <div class="input">
                <form novalidate [formGroup]="packagePriceForm!">
                    <input class="form-control" formControlName="packagePrice" id="packagePrice" placeholder="Csomagár"
                        required type="number" />
                </form>
            </div>
        </div>
        <div class="submit">
            <button (click)="addPackagePrice()">Csomagár mentése</button>
        </div>
    </div>
</div>